/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2025.
 */

const isNode = () =>
	typeof process !== 'undefined' && !!process.versions && !!process.versions.node;

/**
 * Checks if the code is running in a public (browser) environment.
 * @returns true if the code is running in a public (browser) environment,
 *          false if in a Node.js environment.
 */
export const isPublic = () => !isNode();
